import { filter, Observable } from 'rxjs';
import { ViewControl, ViewControlValue } from '../utils/view-control';
import { QtControlAdapter } from './qt-control-adapter';

export class ViewControlAdapter implements QtControlAdapter<ViewControlValue> {
  readonly key = 'view';

  private _suppress = false;

  readonly valueChanges$: Observable<ViewControlValue> =
    this.viewControl.valueChanges$.pipe(filter(() => !this._suppress));

  constructor(readonly viewControl: ViewControl) {}

  applyValue(value: ViewControlValue): void {
    if (!value) return;
    this._suppress = true;
    this.viewControl.setValue(value);
    this._suppress = false;
  }

  getValue(): ViewControlValue {
    return this.viewControl.getValue();
  }
}
